import loadable from '@loadable/component';
export var manifest = {
  TableV2: {
    device: {
      common: {
        component: loadable({
          resolved: {},
          chunkName: function chunkName() {
            return "TableV2";
          },
          isReady: function isReady(props) {
            var key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },
          importAsync: function importAsync() {
            return import(
            /* webpackChunkName: "TableV2" */
            '.');
          },
          requireAsync: function requireAsync(props) {
            var _this = this;

            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function (resolved) {
              _this.resolved[key] = true;
              return resolved;
            });
          },
          requireSync: function requireSync(props) {
            var id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },
          resolve: function resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak(".");
            }

            return eval('require.resolve')(".");
          }
        }, {
          resolveComponent: function resolveComponent(m) {
            return m.TableV2;
          }
        })
      }
    }
  },
  'Table.Caption': {
    device: {
      common: {
        component: loadable({
          resolved: {},
          chunkName: function chunkName() {
            return "TableCaption";
          },
          isReady: function isReady(props) {
            var key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },
          importAsync: function importAsync() {
            return import(
            /* webpackChunkName: "TableCaption" */
            './table-caption');
          },
          requireAsync: function requireAsync(props) {
            var _this = this;

            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function (resolved) {
              _this.resolved[key] = true;
              return resolved;
            });
          },
          requireSync: function requireSync(props) {
            var id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },
          resolve: function resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./table-caption");
            }

            return eval('require.resolve')("./table-caption");
          }
        }, {
          resolveComponent: function resolveComponent(m) {
            return m.TableCaption;
          }
        })
      }
    }
  },
  'Table.Header': {
    device: {
      common: {
        component: loadable({
          resolved: {},
          chunkName: function chunkName() {
            return "TableHeader";
          },
          isReady: function isReady(props) {
            var key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },
          importAsync: function importAsync() {
            return import(
            /* webpackChunkName: "TableHeader" */
            './table-header');
          },
          requireAsync: function requireAsync(props) {
            var _this = this;

            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function (resolved) {
              _this.resolved[key] = true;
              return resolved;
            });
          },
          requireSync: function requireSync(props) {
            var id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },
          resolve: function resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./table-header");
            }

            return eval('require.resolve')("./table-header");
          }
        }, {
          resolveComponent: function resolveComponent(m) {
            return m.TableHeader;
          }
        })
      }
    }
  },
  'Table.HeaderCell': {
    device: {
      common: {
        component: loadable({
          resolved: {},
          chunkName: function chunkName() {
            return "TableHeaderCell";
          },
          isReady: function isReady(props) {
            var key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },
          importAsync: function importAsync() {
            return import(
            /* webpackChunkName: "TableHeaderCell" */
            './table-header-cell');
          },
          requireAsync: function requireAsync(props) {
            var _this = this;

            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function (resolved) {
              _this.resolved[key] = true;
              return resolved;
            });
          },
          requireSync: function requireSync(props) {
            var id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },
          resolve: function resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./table-header-cell");
            }

            return eval('require.resolve')("./table-header-cell");
          }
        }, {
          resolveComponent: function resolveComponent(m) {
            return m.TableHeaderCell;
          }
        })
      }
    }
  },
  'Table.Body': {
    device: {
      common: {
        component: loadable({
          resolved: {},
          chunkName: function chunkName() {
            return "TableBody";
          },
          isReady: function isReady(props) {
            var key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },
          importAsync: function importAsync() {
            return import(
            /* webpackChunkName: "TableBody" */
            './table-body');
          },
          requireAsync: function requireAsync(props) {
            var _this = this;

            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function (resolved) {
              _this.resolved[key] = true;
              return resolved;
            });
          },
          requireSync: function requireSync(props) {
            var id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },
          resolve: function resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./table-body");
            }

            return eval('require.resolve')("./table-body");
          }
        }, {
          resolveComponent: function resolveComponent(m) {
            return m.TableBody;
          }
        })
      }
    }
  },
  'Table.Row': {
    device: {
      common: {
        component: loadable({
          resolved: {},
          chunkName: function chunkName() {
            return "TableRow";
          },
          isReady: function isReady(props) {
            var key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },
          importAsync: function importAsync() {
            return import(
            /* webpackChunkName: "TableRow" */
            './table-row');
          },
          requireAsync: function requireAsync(props) {
            var _this = this;

            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function (resolved) {
              _this.resolved[key] = true;
              return resolved;
            });
          },
          requireSync: function requireSync(props) {
            var id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },
          resolve: function resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./table-row");
            }

            return eval('require.resolve')("./table-row");
          }
        }, {
          resolveComponent: function resolveComponent(m) {
            return m.TableRow;
          }
        }),
        componentSemanticPropsType: {
          path: './src/components/table-row/models/models.manifest.ts',
          name: 'TTableRowSemanticProps'
        }
      }
    }
  },
  'Table.Cell': {
    device: {
      common: {
        component: loadable({
          resolved: {},
          chunkName: function chunkName() {
            return "TableCell";
          },
          isReady: function isReady(props) {
            var key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },
          importAsync: function importAsync() {
            return import(
            /* webpackChunkName: "TableCell" */
            './table-cell');
          },
          requireAsync: function requireAsync(props) {
            var _this = this;

            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function (resolved) {
              _this.resolved[key] = true;
              return resolved;
            });
          },
          requireSync: function requireSync(props) {
            var id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },
          resolve: function resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./table-cell");
            }

            return eval('require.resolve')("./table-cell");
          }
        }, {
          resolveComponent: function resolveComponent(m) {
            return m.TableCell;
          }
        })
      }
    }
  }
};